export default "__VITE_ASSET__B8qTq_SY__"